import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./App.css";
import Layout from "./components/Layout";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import UserForm from "./components/UserForm";
import FAQ from "./components/FAQ";
import Guide from "./components/Guide";
import PageNotFound from "./components/PageNotFound";
import DownloadError from "./components/DownloadError";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Layout.App>
          <Navbar />
          <Routes>
            <Route path="/" element={<UserForm />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="*" element={<PageNotFound />} />
            <Route path="/error" element={<DownloadError />} />
          </Routes>
          <Footer />
        </Layout.App>
      </BrowserRouter>
    </div>
  );
}

export default App;
